import { MenuBook } from "@mui/icons-material";
import { Box, Grid, Typography, useTheme } from "@mui/material";

const FieldNotes = ({ fieldName, noteDate, noteText }) => {
  const theme = useTheme();
  return (
    <Box
      height="100%"
      bgcolor={theme.palette.custom.backgroundColor}
      borderRadius="2px"
      display="flex"
      alignItems="start"
      p={2}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={3}>
          <Box
            display="flex"
            height="100%"
            width="100%"
            alignItems="start"
            gap={2}
          >
            <Box
              bgcolor="white"
              borderRadius="20px"
              p={1}
              display="flex"
              alignItems="center"
              width="40px"
              height="40px"
              justifyContent="center"
            >
              <MenuBook sx={{ fontSize: "12px" }} />
            </Box>
            <Box display="flex" flexDirection="column">
              <Typography sx={{ fontWeight: "bold", fontSize: "12px" }}>
                Titolo nota
              </Typography>
              <Typography sx={{ fontSize: "8px", color: "#616161" }}>
                {fieldName}
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={9}>
          <Box display="flex" flexDirection="column" height="100%" width="100%">
            <Typography sx={{ fontSize: "8px", color: "#616161" }}>
              {noteDate}
            </Typography>
            <Typography sx={{ fontSize: "10px" }}>{noteText}</Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FieldNotes;
